/* 
$( ".form-folding-container" ).slideUp( "fast", function() {
    // start closed form
  });
 */


$(".title-form-folding").click(function () { 
    $( ".form-folding-container" ).slideToggle( "fast", function() {
        // toggle form display
        
      });
});


